import React, { useEffect } from 'react';
import styles from './AlertBanner.module.css';
import { Services, AppUtils } from '@gscope-mfe/app-bridge';
import Message from '../Message';
const { getAlertConfig } = Services;

const AlertBanner = () => {
    const [showBanner, setShowBanner] = React.useState(false);
    const [bannerText, setBannerText] = React.useState('');
    const [showAppBanner, setShowAppBanner] = React.useState(false);
    const [appBannerText, setAppBannerText] = React.useState('');
    const [alertBannerLookup, setAlertBannerLookup] = React.useState({});
    const { userInfo, setAppHomeBanner } = AppUtils.get();

    const displayBanner = (path) => {
        const config = alertBannerLookup[path];
        const alertMsg = config[userInfo.currentMarket] ? config[userInfo.currentMarket] : config.alert;

        if (window.location.pathname === '/apphome') {
            setAppHomeBanner(alertMsg);
            setShowAppBanner(false);
            setShowBanner(false);
            return;
        } else setAppHomeBanner('');

        if (path === '/') {
            setShowAppBanner(true);
            setAppBannerText(alertMsg);
        } else {
            setShowBanner(true);
            setBannerText(alertMsg);
        }
    };

    const setAlertForRoute = () => {
        if (alertBannerLookup && alertBannerLookup['/']) {
            displayBanner('/');
        } else {
            setShowAppBanner(false);
            setAppBannerText('');
        }

        if (alertBannerLookup && alertBannerLookup[window.location.pathname]) {
            displayBanner(window.location.pathname);
        } else {
            setShowBanner(false);
            setBannerText('');
        }
    };

    useEffect(() => {
        getAlertConfig()
            .then((config) => {
                setAlertBannerLookup(config.data);
                config.data ? setAlertForRoute() : null;
            })
            .catch((error) => console.log(error));
    }, []);
    useEffect(() => {
        setAlertForRoute();
    });
    return showBanner || showAppBanner ? (
        <div className={styles.alertBanner}>
            {showAppBanner && <Message variant="warning" style="outlined" message={appBannerText} type="alert" />}
            {showBanner && showAppBanner && (
                <div
                    style={{
                        height: '5px',
                    }}
                ></div>
            )}
            {showBanner && <Message variant="warning" style="outlined" message={bannerText} type="alert" />}
        </div>
    ) : null;
};

export default AlertBanner;
